import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';

import RadioGroup from 'components/shared/controls/RadioGroup';

const RadioGroupField = ({ name, control, rules = {}, feedback, ...restProps }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        // eslint-disable-next-line no-unused-vars
        field: { ref, ...restField },
        fieldState: { error },
        formState: { isSubmitted },
      }) => (
        <RadioGroup
          {...restProps}
          {...restField}
          disabled={restProps.disabled}
          valid={isSubmitted && !error}
          invalid={isSubmitted && error}
          feedback={error?.message || feedback}
        />
      )}
    />
  );
};

RadioGroupField.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
  rules: PropTypes.object,
  feedback: PropTypes.node,
};

export default RadioGroupField;
